// ONB-PARENT step 3: notifications (mock rev3 step 2; R-0137 mapping: reminders = appointments, messages = chat + reports + homework + consult).
//   The two switches only change LOCAL wizard state. NEXT is the gesture: it asks the browser for permission, subscribes this device, and saves profiles.notif_prefs, in that order.
//   Skip after toggling asks for nothing, subscribes nothing and saves nothing.
//   isDone  = at least one switch is on AND this device can get notifications (permission not blocked, not an iPhone/iPad browser tab, push supported).
//   Modes: default (switches start off) · granted (switches start from the saved prefs) · blocked (permission denied: help text, Next off) · ios (a browser tab on iPhone/iPad: add to Home Screen first, Next off).
//   Not offered at all when push cannot work on this browser and it is not an iPhone/iPad tab (no Notification / service worker / PushManager).
const H = () => window.HUD;
const T = (k, v) => H().T(k, v);
const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };

export const MSG_KEYS = ['chat', 'reports', 'homework', 'consult'];
export function isIosTab() {
  const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const standalone = window.navigator.standalone === true || !!(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
  return ios && !standalone;
}
export function supported() { return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window; }
export function applicable() { return supported() || isIosTab(); }
export function modeNow() {
  if (isIosTab()) return 'ios';
  if (!supported()) return 'unsupported';
  const p = Notification.permission; return p === 'denied' ? 'blocked' : p === 'granted' ? 'granted' : 'default';
}
// the saved prefs with the two wizard choices applied; every other key stays as it is
export function buildPrefs(current, remindersOn, messagesOn) {
  const p = Object.assign({}, current);
  p.appointments = !!remindersOn;
  for (const k of MSG_KEYS) p[k] = !!messagesOn;
  return p;
}

export const notificationsStep = {
  id: 'notifications', order: 30,
  applicable,
  label: () => T('onb_notif_label'),
  summary: (r) => (r === 'done' ? T('onb_sum_notif_done') : T('onb_sum_skipped', { label: T('onb_notif_label') })),
  mount(api) {
    const h = H();
    const root = el('div');
    const ic = el('div', 'onb-icon', '🔔'); ic.setAttribute('aria-hidden', 'true');
    const title = el('h2'), sub = el('p', 'onb-sub');
    const mkRow = (emoji) => { const b = el('button', 'onb-switchrow'); b.type = 'button'; b.setAttribute('role', 'switch'); const i = el('span', 'onb-sr-ic', emoji); i.setAttribute('aria-hidden', 'true'); const tx = el('span', 'onb-sr-tx'); const t = el('b'), s = el('small'); tx.append(t, s); const sw = el('span', 'onb-switch'); sw.setAttribute('aria-hidden', 'true'); b.append(i, tx, sw); return { b, t, s }; };
    const rem = mkRow('📅'), msg = mkRow('💬');
    const state = el('p', 'onb-note'); state.setAttribute('data-notif-state', '1');
    const err = el('p', 'onb-error'); err.setAttribute('role', 'alert');
    root.append(ic, title, sub, rem.b, msg.b, state, err);
    let mode = modeNow(), remOn = false, msgOn = false;
    function start() {
      mode = modeNow();
      if (mode === 'granted') { const p = (h.DB && h.DB.notifPrefs) || {}; remOn = p.appointments === true; msgOn = MSG_KEYS.every(k => p[k] !== false); }
    }
    start();
    function paint() {
      const locked = mode === 'blocked' || mode === 'ios' || mode === 'unsupported';
      [[rem, remOn], [msg, msgOn]].forEach(([r, on]) => { r.b.setAttribute('aria-checked', on ? 'true' : 'false'); r.b.classList.toggle('is-on', on); r.b.disabled = locked; });
      state.textContent = mode === 'blocked' ? T('onb_notif_blocked_help') : mode === 'ios' ? T('onb_notif_ios') : T('onb_notif_note');
    }
    function texts() {
      title.textContent = T('onb_notif_title'); sub.textContent = T('onb_notif_sub');
      rem.t.textContent = T('onb_notif_rem_title'); rem.s.textContent = T('onb_notif_rem_sub');
      msg.t.textContent = T('onb_notif_msg_title'); msg.s.textContent = T('onb_notif_msg_sub'); paint();
    }
    texts();
    rem.b.addEventListener('click', () => { if (rem.b.disabled) return; remOn = !remOn; paint(); api.refresh(); });
    msg.b.addEventListener('click', () => { if (msg.b.disabled) return; msgOn = !msgOn; paint(); api.refresh(); });
    return {
      el: root,
      isDone: () => (mode === 'default' || mode === 'granted') && (remOn || msgOn),
      async commit() {
        const sess = h.session; if (!sess || !sess.id) return { ok: false, error: T('onb_error_generic') };
        // the browser prompt must come from THIS click: first statement, before any other await
        const r = await h._enablePushFromGesture();
        if (!r.ok) {
          mode = modeNow(); paint(); api.refresh();
          return { ok: false, error: r.reason === 'denied' ? (mode === 'blocked' ? T('onb_notif_denied') : T('onb_notif_dismissed')) : T('onb_error_generic') };
        }
        const prefs = buildPrefs((h.DB && h.DB.notifPrefs) || {}, remOn, msgOn);
        const { error } = await h._supa.from('profiles').update({ notif_prefs: prefs }).eq('id', sess.id);
        if (error) { console.error('❌ onboarding notif_prefs save:', error); return { ok: false, error: T('onb_error_generic') }; }
        h.DB.notifPrefs = prefs;
        return { ok: true };
      },
      onEnter() { const m = modeNow(); if (m !== mode) { mode = m; if (m === 'granted') start(); paint(); api.refresh(); } },
      relang: texts,
    };
  },
};
